import { PromotionPlanInfo, PromotionPlanLevel } from 'store/sagas/apiService/types';

export const isBulletinLevelPromotionPlanVariant = (plan: PromotionPlanInfo) => {
  return plan.level === PromotionPlanLevel.BULLETIN;
};

export const isAccountLevelPromotionPlanVariant = (plan: PromotionPlanInfo) => {
  return plan.level === PromotionPlanLevel.ACCOUNT;
};
